import { createSelector } from 'react-sweet-state';

import type { FormRendererState } from '../../types';

export const renderersSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	void,
	import('../../../..').Renderers
> = createSelector(
	(state: FormRendererState) => state.renderers,
	(renderers) => renderers,
);
